import React, { Component } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';

import { Header } from './components/Header/index';
import { ErrorBoundary } from './components/ErrorBoundary/index';
import { Company } from './screens/Company/index';
import { NotFound } from './screens/NotFound/index';
import { AssessmentReport } from './screens/AssessmentReport/index';
import { AssessmentManager } from './screens/AssessmentManager/index';
import { Dashboard } from './screens/Dashboard/index';
import { Question } from './screens/Question/index';

import './app.css';


class App extends Component {

  componentDidMount() {
    const ele = document.getElementById('ipl-progress-indicator')
    if (ele) {
      setTimeout(() => {
        ele.classList.add('available')
        setTimeout(() => {
          ele.outerHTML = ''
        }, 500)
      }, 500)
    }
  }

  questionComponent;
  saveAnsweredQuestions = () => {
    this.questionComponent.getWrappedInstance().handleUpdateAnsweredQuestions();
  }

  render() {
    const mainApp = <ErrorBoundary {...this.props}>
      <Header {...this.props} keyCloak={this.props.keyCloak} saveAnsweredQuestions={this.saveAnsweredQuestions} />
      <div className="container-fluid app-content">
        <Switch>
          <Route exact path="/">
            <Redirect to="/dashboard" />
          </Route>
          <Route path="/dashboard" component={props => <Dashboard {...props} cookies={this.props.cookies} />} />
          <Route
            path="/organization-question"
            component={props => <Question {...props} ref={(r) => this.questionComponent = r} />}
          />
          <Route
            path="/technology-question"
            component={props => <Question {...props} ref={(r) => this.questionComponent = r} />}
          />
          <Route
            path="/question"
            component={props => <Question {...props} ref={(r) => this.questionComponent = r} />}
          />
          <Route path="/assessment-report" component={AssessmentReport} />
          <Route path="/assessment-manager" component={(props) => <AssessmentManager {...props} keyCloak={this.props.keyCloak} cookies={this.props.cookies} />} />
          <Route path="/company" component={props => <Company {...props} cookies={this.props.cookies} />} />
          <Route path="*" component={NotFound} />
        </Switch>
      </div>
    </ErrorBoundary>

    const { location } = this.props.history;
    const publicPaths = ['/']
    const currentPath = location.pathname;
    if (publicPaths.indexOf(currentPath) === -1) {
      if (!this.props.account) {
        this.props.keyCloak.login();
        return null
      } else {
        return mainApp
      }
    } else {
      return mainApp
    }
  }
}
export default App;



// WEBPACK FOOTER //
// ./src/App.js